// import React, { useEffect, useState, useRef } from 'react';
// import './InfoStatsSection.css';

// // Hook to animate numbers smoothly
// function useCountUp(targetValue, duration = 1500, startAnimate = false) {
//   const [count, setCount] = useState(0);

//   useEffect(() => {
//     if (!startAnimate) return;

//     // Extract numerical value (e.g., "2500+" -> 2500)
//     const numericTarget = parseInt(targetValue.toString().replace(/[^0-9]/g, ''), 10);
//     if (isNaN(numericTarget)) {
//       setCount(targetValue);
//       return;
//     }

//     let startTimestamp = null;
//     const step = (timestamp) => {
//       if (!startTimestamp) startTimestamp = timestamp;
//       const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      
//       // Calculate modern easeOutQuad progressive curve
//       const easeProgress = progress * (2 - progress);
//       const currentCount = Math.floor(easeProgress * numericTarget);

//       setCount(currentCount);

//       if (progress < 1) {
//         window.requestAnimationFrame(step);
//       } else {
//         // Ensure it appends the exact string suffix back (+ or original string)
//         const suffix = targetValue.toString().replace(/[0-9]/g, '');
//         setCount(`${numericTarget}${suffix}`);
//       }
//     };

//     window.requestAnimationFrame(step);
//   }, [targetValue, duration, startAnimate]);

//   return count;
// }

// // Individual Card Component to track internal scroll visibility
// function StatCard({ stat, startAnimate }) {
//   const animatedValue = useCountUp(stat.value, 2000, startAnimate);

//   return (
//     <div className="stat-card">
//       <div className="stat-icon-box">
//         <span className="stat-icon">{stat.icon}</span>
//       </div>
//       <h2 className="stat-value">{startAnimate ? animatedValue : 0}</h2>
//       <p className="stat-label">{stat.label}</p>
//     </div>
//   );
// }

// export default function InfoStatsSection() {
//   const [hasIntersected, setHasIntersected] = useState(false);
//   const sectionRef = useRef(null);

//   const tickerItems = [
//     "September 30, 2025",
//     "NAAC A++ Accredited University",
//     "46+ Years of Academic Excellence",
//     "85,000+ Students Enrolled",
//     "280+ Study Centres Across India",
//     "🎓 Admissions Open for AY 2025–26"
//   ];

//   const statItems = [
//     {
//       id: 1,
//       icon: "👥",
//       value: "2500+",
//       label: "Students Enrolled"
//     },
//     {
//       id: 2,
//       icon: "📖",
//       value: "50+",
//       label: "Programs Offered"
//     },
//     {
//       id: 3,
//       icon: "🏢",
//       value: "20+",
//       label: "Study Centres"
//     },
//     {
//       id: 4,
//       icon: "🏅",
//       value: "5",
//       label: "Years of Excellence"
//     }
//   ];

//   // Intersection Observer triggers counter only when scrolled into view
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setHasIntersected(true);
//           observer.disconnect(); // Runs animation once per page load
//         }
//       },
//       { threshold: 0.15 } // Fires when 15% of the component becomes visible
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     return () => observer.disconnect();
//   }, []);

//   return (
//     <div className="info-stats-container" ref={sectionRef}>
//       {/* 1. Yellow Continuous Ticker Scroller */}
//       <div className="ticker-wrapper">
//         <div className="ticker-track">
//           {tickerItems.map((item, idx) => (
//             <span key={`orig-${idx}`} className="ticker-item">
//               {item} <span className="ticker-divider">|</span>
//             </span>
//           ))}
//           {tickerItems.map((item, idx) => (
//             <span key={`clone-${idx}`} className="ticker-item">
//               {item} <span className="ticker-divider">|</span>
//             </span>
//           ))}
//         </div>
//       </div>

//       {/* 2. Deep Blue Statistics Grid */}
//       <section className="stats-grid-section">
//         <div className="stats-grid-container">
//           {statItems.map((stat) => (
//             <StatCard 
//               key={stat.id} 
//               stat={stat} 
//               startAnimate={hasIntersected} 
//             />
//           ))}
//         </div>
//       </section>
//     </div>
//   );
// }


import React, { useEffect, useState, useRef } from 'react';
import './InfoStatsSection.css';

// Hook to animate numbers smoothly
function useCountUp(targetValue, duration = 1500, startAnimate = false) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!startAnimate) return;

    // Extract numerical value (e.g., "2500+" -> 2500)
    const numericTarget = parseInt(targetValue.toString().replace(/[^0-9]/g, ''), 10);
    if (isNaN(numericTarget)) {
      setCount(targetValue);
      return;
    }

    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      
      // Calculate modern easeOutQuad progressive curve
      const easeProgress = progress * (2 - progress);
      const currentCount = Math.floor(easeProgress * numericTarget);

      setCount(currentCount);

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        // Appends the exact string suffix back (+ or original string)
        const suffix = targetValue.toString().replace(/[0-9]/g, '');
        setCount(`${numericTarget}${suffix}`);
      }
    };

    window.requestAnimationFrame(step);
  }, [targetValue, duration, startAnimate]);

  return count;
}

// Individual Card Component to track internal scroll visibility
function StatCard({ stat, startAnimate }) {
  const animatedValue = useCountUp(stat.value, 2000, startAnimate);

  return (
    <div className="stat-card">
      <div className="stat-icon-box">
        <span className="stat-icon">{stat.icon}</span>
      </div>
      <h2 className="stat-value">{startAnimate ? animatedValue : 0}</h2>
      <p className="stat-label">{stat.label}</p>
    </div>
  );
}

export default function InfoStatsSection() {
  const [hasIntersected, setHasIntersected] = useState(false);
  const [statItems, setStatItems] = useState([

    { id: '4', icon: "🏅", value: "46+", label: "Years of Excellence" }
  ]);
  const sectionRef = useRef(null);

  // Extract dynamic values for ticker items with fallback defaults
  const studentCount = statItems.find(item => item.label === 'Students Enrolled')?.value || '3+';
  const universityCount = statItems.find(item => item.label === 'Universities Partnered')?.value || '3+';
  const programCount = statItems.find(item => item.label === 'Programs Offered')?.value || '13+';

  // Dynamic Ticker Items Array
  const tickerItems = [
    "NAAC A++ Accredited University",
    "46+ Years of Academic Excellence",
    `${studentCount} Active Students Enrolled`,
    `${universityCount} Partner Universities`,
    `${programCount} Academic Programs Available`,
    "🎓 Admissions Open for AY 2026–27"
  ];

  // Fetch dynamic stats from API
  useEffect(() => {
    const fetchDashboardStats = async () => {
      try {
        const response = await fetch('https://metapi.emedhatechnologies.com/api/courses/dashboard-stats');
        const result = await response.json();

        if (result.success && Array.isArray(result.data)) {
          const dynamicStats = result.data.map((item) => {
            let label = item.title;
            if (item.title.toLowerCase() === 'courses') {
              label = 'Programs Offered';
            } else if (item.title.toLowerCase() === 'students') {
              label = 'Students Enrolled';
            } else if (item.title.toLowerCase() === 'universities') {
              label = 'Universities Partnered';
            }

            return {
              id: item.id,
              icon: item.icon || '📖',
              value: item.value || '0',
              label: label
            };
          });

          const staticExcellenceCard = {
            id: 'static-excellence',
            icon: '🏅',
            value: '46+',
            label: 'Years of Excellence'
          };

          setStatItems([...dynamicStats, staticExcellenceCard]);
        }
      } catch (error) {
        console.error('Error fetching dashboard stats:', error);
      }
    };

    fetchDashboardStats();
  }, []);

  // Intersection Observer
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHasIntersected(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="info-stats-container" ref={sectionRef}>
      
      {/* Dynamic Yellow Continuous Ticker Scroller */}
      <div className="ticker-wrapper">
        <div className="ticker-track">
          {tickerItems.map((item, idx) => (
            <span key={`orig-${idx}`} className="ticker-item">
              {item} <span className="ticker-divider">|</span>
            </span>
          ))}
          {tickerItems.map((item, idx) => (
            <span key={`clone-${idx}`} className="ticker-item">
              {item} <span className="ticker-divider">|</span>
            </span>
          ))}
        </div>
      </div>

      {/* Deep Blue Statistics Grid */}
      <section className="stats-grid-section">
        <div className="stats-grid-container">
          {statItems.map((stat) => (
            <StatCard 
              key={stat.id} 
              stat={stat} 
              startAnimate={hasIntersected} 
            />
          ))}
        </div>
      </section>

    </div>
  );
}